import LazyLoadVue from "./plugins/LazyLoadVue";

export default LazyLoadVue;
